export default __webpack_public_path__ + "static/media/litho-templates-library-01.df666082.jpg";